export default {
    url: 'ocean-smart-meter-backup-switch',
    include: ['us'],
};
